/**
 * marketing-targets.ts — W55 hardcoded target constants.
 *
 * To swap to settings-driven values in a future wave, replace each export with
 * a settings lookup (e.g. from /api/settings/marketing-targets) and keep the
 * same export names so all components stay unchanged.
 *
 * W55 defaults reviewed by Bryan K. Short (Mi6 Group).
 */

// ─── MQL Targets ──────────────────────────────────────────────────────────────

/** Annual MQL target (sum of all quarters). */
export const MQL_TARGET_ANNUAL = 600;

/** Quarterly MQL targets */
export const MQL_TARGET_BY_QUARTER: Record<1 | 2 | 3 | 4, number> = {
  1: 120,
  2: 150,
  3: 160,
  4: 170,
};

/** Monthly MQL targets — Q1..Q4 × 3 months */
export const MQL_TARGET_BY_MONTH: Record<number, number> = {
  1: 36,   // January   (Q1 ~120)
  2: 42,   // February
  3: 42,   // March
  4: 45,   // April     (Q2 ~150)
  5: 52,   // May
  6: 53,   // June
  7: 50,   // July      (Q3 ~160)
  8: 55,   // August
  9: 55,   // September
  10: 52,  // October   (Q4 ~170)
  11: 60,  // November
  12: 58,  // December
};

// ─── Funnel / Conversion Targets ──────────────────────────────────────────────

/** BDR acceptance rate target (MQL → SAL) */
export const BDR_ACCEPTANCE_TARGET_PCT = 50;

/** Minimum acceptable qualification floor (% of pipeline above OMITTED) */
export const QUALIFICATION_FLOOR_PCT = 40;

/** Engagement rate target (cadence touches → engagements) */
export const ENGAGEMENT_RATE_TARGET_PCT = 12;

// ─── Channel defaults ─────────────────────────────────────────────────────────

export const CHANNEL_LABELS: Record<string, string> = {
  linkedin: "LinkedIn ads",
  webinar: "Webinar",
  content_syndication: "Content syndication",
  roundtable: "Roundtable events",
  inbound: "Inbound web",
};
